






























































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import DonutChart from "@/components/Charts/DonutChart.vue";
import PinBoardPage from "@/components/PinBoard.vue";
import Badge from "@/components/html/Badge.vue";
import { PinBoard } from "@/models/pinboard.model";
import PinboardModal from "@/components/Admin/PinboardModal.vue";
import JobModal from "@/components/Admin/JobModal.vue";
import store from "../store/store";
import { Action } from "@/models/app.model";

@Component({
    computed: mapGetters({
        totJobDone: "job/getJobDoneNumber",
        totJob: "job/getJobNumber",
        totJobRemaining: "job/getJobRemainingNumber",
        isAdmin: "auth/isAdmin",
        pinBoardName: "app/currentPinBoardName",
    }),
    components: {
        Badge,
        DonutChart,
        PinBoardPage,
        PinboardModal,
        JobModal,
    },
})
export default class PinBoardView extends Vue {
    pinboards: PinBoard[] = [];
    activePinBoardId = 0;
    activeCardId = "";
    action = Action;

    pinboardId: number = 0;
    isModalVisible: boolean = false;
    isJobModalVisible: boolean = false;

    // value:any = [];
    // options:any = [
    //     { name: 'Vue.js', language: 'JavaScript' },
    //     { name: 'Adonis', language: 'JavaScript' },
    //   ];

    createNewTodoFromCard() {
        this.$store.dispatch("job/editJob", {
            jobId: -1,
            action: this.action.new,
        });
    }

    created() {}

    clickItem() {}

    async mounted() {
        this.load();
    }

    load() {
        this.activePinBoardId = this.currentPinBoards[0].id!;
        this.$store.dispatch("app/setCurrentPinBoard", this.activePinBoardId);
    }

    async setPinBoard(val: any) {
        this.activePinBoardId = val;

        if (this.$route.params.cardid != undefined) {
            this.$router.replace({
                name: "currentCard",
                params: {
                    pinBoardId: this.activePinBoardId.toString(),
                    cardid: this.$route.params.cardid,
                },
            });
        } else {
            this.$router.replace({
                name: "currentPinboard",
                params: { pinBoardId: this.activePinBoardId.toString() },
            });
        }
        this.$store.dispatch("app/setCurrentPinBoard", val);

        await this.$store.dispatch(
            "app/getCompanyPinBoards",
            store.getters["auth/companyId"]
        );
    }

    currentIndex = 0;
    async changePinBoard() {
        if (this.currentIndex == this.currentPinBoards.length - 1)
            this.currentIndex = 0;
        else this.currentIndex++;

        this.setPinBoard(this.currentPinBoards[this.currentIndex].id);

        // this.setPinBoard(this.currentPinBoards[this.currentIndex == this.currentPinBoards.length-1 ? 0 : this.currentIndex++].id);
    }

    destroyed() {
        this.$store.dispatch("app/setCurrentPinBoard", 0);
    }

    openModal() {
        this.pinboardId = 0;
        this.isModalVisible = true;
    }

    modalEvent(obj: any) {
        this.isModalVisible = obj == "close" || obj == "saved" ? false : true;
        if ((obj = "saved")) {
            this.$store.dispatch(
                "app/getCompanyInfoFromKey",
                store.getters["auth/companyId"]
            );
            this.pinboards = this.$store.getters["app/pinboards"];
        }
    }

    @Watch("$route", { immediate: true, deep: true })
    async onUrlChange(newVal: any) {
        this.activeCardId = "";
        if (newVal.params.cardid !== undefined) {
            this.$router.replace({
                name: "currentCard",
                params: {
                    pinBoardId: this.activePinBoardId.toString(),
                    cardid: newVal.params.cardid,
                },
            });
            this.activeCardId = newVal.params.cardid;
        } else {
            this.$router
                .replace({
                    name: "currentPinboard",
                    params: { pinBoardId: this.activePinBoardId.toString() },
                })
                .catch(() => {});
            this.activeCardId = "";
        }
        // Some action
    }

    get currentPinBoards() {
        return this.$store.getters["app/pinboards"];
    }
}
